<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="47.562" height="45.267" viewBox="0 0 57.562 55.267">
      <path id="star-comment-alt-2"
            d="M19.666,60.024a4.86,4.86,0,0,1-2.881-.943,4.779,4.779,0,0,1-1.676-5.291l4.505-14.458L8.194,30.06a4.778,4.778,0,0,1,3.091-8.434H25.69L30.772,7.953a4.8,4.8,0,0,1,9.01,0l5.081,13.673H59.269a4.811,4.811,0,0,1,4.505,3.143,4.9,4.9,0,0,1-1.414,5.343L50.993,39.384l4.715,14.3a4.755,4.755,0,0,1-1.624,5.291,4.8,4.8,0,0,1-5.553.21l-13.2-8.591-12.992,8.7a4.829,4.829,0,0,1-2.672.786Z"
            transform="translate(-6.496 -4.81)" />
    </svg>
  </template>
  